import { Pipe, PipeTransform } from '@angular/core';

import { LanguageSelectionService } from '../services/language-selection.service';

@Pipe({
  name: 'fsNumber',
  pure: false,
})
export class FsNumberPipe implements PipeTransform {
  constructor(private readonly _languageService: LanguageSelectionService) {}

  transform(
    value: number | string | null | undefined,
    digitsInfo?: string
  ): string {
    if (value == null || value === '') {
      return '';
    }

    const numValue = typeof value === 'string' ? parseFloat(value) : value;

    if (isNaN(numValue)) {
      return '';
    }

    const formattingLocale = this._languageService.getCurrentLocale();
    const options = this._parseDigitsInfo(digitsInfo);
    
    try {
      return new Intl.NumberFormat(formattingLocale, options).format(numValue);
    } catch (error) {
      return new Intl.NumberFormat('en-US', options).format(numValue);
    }
  }

  private _parseDigitsInfo(digitsInfo?: string): Intl.NumberFormatOptions {
    if (!digitsInfo) {
      return {
        minimumFractionDigits: 0,
        maximumFractionDigits: 3,
      };
    }

    const parts = digitsInfo.split('.');
    const fractionPart = parts[1] || '0-3';
    const [minFraction, maxFraction] = fractionPart.split('-').map(Number);

    return {
      minimumFractionDigits: minFraction,
      maximumFractionDigits: maxFraction !== undefined ? maxFraction : minFraction,
    };
  }
}

